import React from 'react';

const AsyncAddPost = React.lazy(() => import('./PostsContainer'));

export const AddPostPage = () => {
  return <AsyncAddPost />;
};
